export enum GamificationActivityName {
    ACHIEVE = 'achieve',
    LEVEL_UP = 'level_up',
}

export enum GamificationActivityType {
    BADGE = 'badge',
    INBOX = 'inbox',
}

export enum GamificationConditionOperator {
    AND = 'and',
    OR = 'or',
}

// The types are agreed with business
// https://betgamestv.atlassian.net/wiki/spaces/DEVEL/pages/12064107/Data+sent+to+Captain+Up
// Depending on type different behaviour will be applied
export enum GamificationInboxTypes {
    LEVEL_UP = 'level_up',
}

export enum GamificationAssetType {
    SHOP = 'shop_item',
    TROPHY = 'trophy_item',
}

export enum GamificationCapType {
    DAILY = 'daily',
    WEEKLY = 'weekly',
    MONTHLY = 'monthly',
}

export enum GamificationCurrency {
    POINTS = 'points',
    COINS = 'coins',
}

export enum GamificationCondition {
    PLACE_BET = 'place_bet',
    PAY_OUT = 'pay_out',
}

export enum GamificationConditionFilter {
    GAMES_IDS = 'game_ids',
    BET_AMOUNT = 'bet_amount',
    BET_STATUS = 'bet_status',
    ODD_VALUE = 'odd_value',
    ODD_CLASSES = 'odd_classes',
    ROUND_NUMBER = 'round_number',
    BET_ITEMS = 'bet_items',
}
